import axiosInstance from "../config/axios-config";

const options = (language, signal) => ({headers: {"Language-Context": language.toUpperCase()}, signal});

export const canManageCouriers = role => ["ADMIN", "SYSTEM"].includes(role);

export const getCourierTracking = async (filters, language, signal) => {
    const {data} = await axiosInstance.get("/api/v1/couriers/tracking", {...options(language, signal), params: filters, timeout: 10000});
    return data;
};

export const getCourierDashboard = async (filters, language, signal) => {
    const {data} = await axiosInstance.get("/api/v1/couriers/dashboard", {...options(language, signal), params: filters});
    return data;
};

export const getCouriers = async (page, size, language, signal) => {
    const {data} = await axiosInstance.get("/api/v1/couriers", {...options(language, signal), params: {page, size}});
    return data;
};

export const getCourierUsers = async (search, page, language, signal) => {
    const {data} = await axiosInstance.get("/api/v1/users/all", {...options(language, signal),
        params: {role: "COURIER", active: true, search: search.trim() || undefined, page, size: 20, sort: "firstName,asc"}});
    return data;
};

export const createCourier = async (profile, language) => {
    const {data} = await axiosInstance.post("/api/v1/couriers", profile, options(language));
    return data;
};

export const updateCourier = async (id, changes, language) => {
    const {data} = await axiosInstance.put(`/api/v1/couriers/${id}`, changes, options(language));
    return data;
};

export const getCourierOrders = async (id, activeOnly, page, size, language, signal) => {
    const {data} = await axiosInstance.get(`/api/v1/couriers/${id}/orders`,
        {...options(language, signal), params: {activeOnly, page, size}});
    return data;
};
